import { Box, Button, Grid, Typography } from '@mui/material';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useSelector } from '../../../redux/store';
import { DASHBOARD_TICKETS } from '../../../reusable-components/datagrid/ticketColumns';
import Iconify from '../../../reusable-components/iconify';
import { useScopeCheck } from '../../../reusable-components/scopes';

export default function DashboardTickets() {
  const navigate = useNavigate();
  const hasViewOrderAccess = useScopeCheck(['Submit-Order'], true);
  const { tickets } = useSelector((state) => state.dashboard.data);
  return (
    <>
      <Grid container direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="subtitle1" color="primary" sx={{ ml: 0.5 }}>
          Tickets
        </Typography>
        <Button
          to="/dashboard/tickets"
          component={RouterLink}
          endIcon={<Iconify icon="eva:arrow-forward-fill" width={15} height={5} />}
        >
          View all
        </Button>
      </Grid>
      <Box sx={{ height: hasViewOrderAccess ? '34vh' : '75vh', width: '100%', mb: 3 }}>
        <DataGridPro
          // getRowHeight={() => 'auto'} // this makes the label on the left out of sync
          rows={tickets ?? []}
          columns={DASHBOARD_TICKETS}
          getRowId={(row) => row.id}
          onRowClick={(params) => {
            const selection = window.getSelection().toString();
            if (selection.length > 0) return;
            navigate(`/dashboard/tickets/${params.row.id}`);
          }}
          hideFooter
          // sx={{
          //   '& .MuiDataGrid-virtualScroller::-webkit-scrollbar': { display: 'none' },
          // }}
        />
      </Box>
    </>
  );
}
